module.exports = __webpack_public_path__ + "static/media/lightning-2.a7c23769.svg";